// TODO RESOLVE ALL NULL CHECKS
const subSlider = document.querySelector('.slide_round')

if (subSlider) {
  subSlider.addEventListener('change', function(e) {
    if (this.checked) {
      document.dispatchEvent(new CustomEvent('subscription-on'))
    } else {
      document.dispatchEvent(new CustomEvent('subscription-off'))
    }
  })
  document.addEventListener('DOMContentLoaded', () => {
    if (localStorage.getItem("subscription_option") === 'yes') {
      subSlider.checked = true
      subSlider.dispatchEvent(new Event('change'))
    }
  })
}

if (!customElements.get("byo-controller")) {
  class BYOController extends HTMLElement {
    constructor() {
      super();

      this.cartCurrency = '$'
      
      this.compare_amount = 0 
      this.shownMobile = this.dataset.mobileEmpty
      this.shownTotal =  this.dataset.emptyTotal
      
      this.isSub = false
      this.byoAmount = 0
      this.maxTier = 0
      this.products = []
      this.grantedFreeGifts = []
      this.selectedFreeGifts = []
      this.tiers = this.querySelectorAll('byo-tier')
      this.progressBar = this.querySelector('.progress-bar')
      this.progressWrapper = this.querySelector('.progress-container')
      this.addToCart = this.querySelector('.add_bundle_cart')
      this.cartPrice = this.querySelector('.cart_price')
      
      this.productTemplate = this.querySelector('#bundle-item')
      this.emptyTemplate = this.querySelector('#bundle-item--empty')
      this.emptyBuilderMessage = this.querySelector('.without_img_text')
      this.builderContents = this.querySelector('.bundleproducts')
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
        this.getDependantData()
        this.intializeSetVariables();
        this.setupObservers()
      });
    }
    attachListeners() {
      document.addEventListener('update-bundle-item', this.updateBundleItem.bind(this))
      document.addEventListener('remove-from-bundle', this.removeBundleItem.bind(this))
      document.addEventListener('add-to-bundle', this.addBundleItem.bind(this))
      document.addEventListener('subscription-on', () => {
        this.isSub = true
        this.updateUI()
      })
      document.addEventListener('subscription-off', () => {
        this.isSub = false
        this.updateUI()
      })
      document.addEventListener('granted-free-gift', this.addGrantedFreeGift.bind(this))
      document.addEventListener('remove-granted-free-gift', this.removeGrantedFreeGift.bind(this))
      document.addEventListener('selected-free-gift', this.addSelectedFreeGift.bind(this))
      document.addEventListener('remove-selected-free-gift', this.removeSelectedFreeGift.bind(this))
      this.addToCart.addEventListener('click', this.handleAddToCart.bind(this))
    }
    addBundleItem({detail}) {
      this.products.push(detail)
      this.updateUI()
    }
    updateBundleItem({detail}) {
      console.log(detail);
      const matchingProduct = this.products.find((product) => product.id == detail.id)
      if (matchingProduct) {
        matchingProduct.quantity = detail.quantity
      }
      this.updateUI()
    }
    removeBundleItem({detail}) {
      const matchingProduct = this.products.find((product) => product.id == detail.id)
      if (matchingProduct) {
        this.products.splice(this.products.indexOf(matchingProduct),1)
      }
      this.updateUI()
    }
    updateUI() {
      this.updateAmount()
      this.updateBoxUI()
      this.updateButton()
      this.updateTiers()
      this.updateProgressBar()
      this.updateSavedData()
    }
    updateAmount() {
      this.amount = this.isSub ? this.products.reduce((prev, next) => prev + (parseInt(next.sub_price||next.price) * next.quantity), 0) / 100 : this.products.reduce((prev, next) => prev + (parseInt(next.price) * next.quantity), 0) / 100
      this.compare_amount = this.products.reduce((prev, next) => prev + (parseInt(next.price) * next.quantity), 0) / 100
      this.amount = this.amount.toFixed(2)
      this.compare_amount = this.compare_amount.toFixed(2)
    }
    updateBoxUI() {
      const totalProductCount = this.products.length + this.grantedFreeGifts.length + this.selectedFreeGifts.length
      const template = this.productTemplate.content.cloneNode(true);
      const emptyTemplate = this.emptyTemplate.content.cloneNode(true);
      // TODO get this moved out to the proper location
      const contents = document.querySelector('.bundleproducts')
      const messageContainer = document.querySelector('.without_img_text')
      if (totalProductCount === 0) {
        messageContainer.classList.remove('hide_button')
      } else {
        messageContainer.classList.add('hide_button')
      }
      
      contents.innerHTML = ''
      if (totalProductCount < this.shownTotal) {
        if (this.shownMobile <= totalProductCount && this.shownMobile) {
          for ( let i = 0; i < this.shownTotal - totalProductCount; i ++ ) {
            const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
            emptyItem.classList.add('hidemobile')
            contents.appendChild(emptyItem)
          }
        } else {
          for ( let i = 0; i < this.shownTotal - totalProductCount; i ++ ) {
            const emptyItem = emptyTemplate.firstElementChild.cloneNode(true);
            if ((!totalProductCount && i + 1 <= this.shownMobile && this.shownMobile) || totalProductCount) {
              emptyItem.classList.add('hidemobile')
            }
            contents.appendChild(emptyItem)
          }
        }
      }
      this.products.forEach((product) => {
          const newProduct = template.firstElementChild.cloneNode(true);
          newProduct.classList.add(`product_box_${product.id}`)
          newProduct.querySelector('img').src = product.image
          newProduct.querySelector('.qty_wrapper').innerText = product.quantity
          newProduct.querySelector('.top_free').classList.add('hide_button')
          newProduct.querySelector('a').innerText = product.title
          newProduct.querySelector('.top_icon').addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('removed-from-box', {
              detail: {
                id: product.id
              }
            }))
          })
          contents.prepend(newProduct)
      })
    
      const gifts = this.grantedFreeGifts.concat(this.selectedFreeGifts)
      gifts.forEach((product) => {
        const newProduct = template.firstElementChild.cloneNode(true);
        newProduct.classList.add(`product_box_${product.id}`)
        newProduct.querySelector('img').src = product.image
        newProduct.querySelector('.icon_qty').classList.add('hide_button')
        newProduct.querySelector('a').innerText = product.title
        newProduct.querySelector('.top_icon').classList.add('hide_button')
        contents.prepend(newProduct)
    })
    }
    updateButton() {
      if (this.cartPrice) {
        let priceHtml = `
          <ins>${this.cartCurrency}${this.amount}</ins>
        `
        if (this.isSub && this.amount > 0 && this.compare_amount) {
          priceHtml = `
            <del>
              ${this.cartCurrency}
              ${this.compare_amount}
            </del>
            <ins>${this.cartCurrency}${this.amount}</ins>
          `
        }
        this.cartPrice.innerHTML = priceHtml
      }
    }
    updateTiers() {
      const appliedTiers = this.selectedFreeGifts.concat(this.grantedFreeGifts).map((item) => item.tier)
      this.tiers.forEach((tier) => {
        tier.maybeApplyTier(this.amount, appliedTiers)
      })
    }
    setupObservers() {
      const resizeObserver = new ResizeObserver((entries) => {
        this.updateProgressBar()
        console.log("Size changed");
      });
      
      resizeObserver.observe(document.querySelector('body'));
    }
    updateProgressBar() {
      if (this.progressBar && this.progressWrapper) {
        const nextUnappliedTier = [...this.tiers].find((tier) => !tier.getTierApplied())
        if (nextUnappliedTier) {

          const nextUnappliedTierIndex = [...this.tiers].indexOf(nextUnappliedTier)
          const tierIndex = nextUnappliedTierIndex + 1
          const maxSize = ((1 / [...this.tiers].length).toFixed(2) * tierIndex) * this.progressWrapper.offsetWidth
          const amountFilled = this.amount / nextUnappliedTier.getTierAmount()

          this.progressBar.style =`background:black;width: ${maxSize * amountFilled}px`
        } else {
          this.progressBar.style =`background:black;width: 100%;`
        }
        
      }
    }
    addGrantedFreeGift({detail}) {
      const matchingProduct = this.grantedFreeGifts.find((product) => product.tier == detail.tier)
      if (!matchingProduct) {
        this.grantedFreeGifts.push(detail)
      }
      console.log(detail);
      this.updateBoxUI()
      this.updateSavedData()
    }
    removeGrantedFreeGift({detail}) {
      const matchingProduct = this.grantedFreeGifts.find((product) => product.tier == detail.tier)
      if (matchingProduct) {
        this.grantedFreeGifts.splice(this.grantedFreeGifts.indexOf(matchingProduct),1)
      }
      this.updateBoxUI()
      this.updateSavedData()
    }
    addSelectedFreeGift({detail}) {
      const matchingProduct = this.selectedFreeGifts.find((product) => product.tier == detail.tier)
      if (!matchingProduct) {
        this.selectedFreeGifts.push(detail)
      }
      this.updateBoxUI()
      this.updateSavedData()
    }
    removeSelectedFreeGift({detail}) {
      const matchingProduct = this.selectedFreeGifts.find((product) => product.tier == detail.tier)
      if (matchingProduct) {
        this.selectedFreeGifts.splice(this.selectedFreeGifts.indexOf(matchingProduct),1)
      }
      this.updateBoxUI()
      this.updateSavedData()
    }
    getDependantData() {
      this.tiers.forEach((tier) => {
        const tierAmount = tier.getTierAmount()
        if (this.maxTier < tierAmount) {
          this.maxTier = tierAmount
        }
      })
    }
    handleAddToCart() {
      const items = []
      this.grantedFreeGifts.forEach((gift) => {
        items.push({
          id: gift.id,
          quantity: 1,
          properties: {
            _freegift: true,
            _granted: true
          },
        })
      })
      this.selectedFreeGifts.forEach((gift) => {
        items.push({
          id: gift.id,
          quantity: 1,
          properties: {
            _freegift: true
          },
        })
      })
      this.products.forEach((product) => {
        const item = {
          id: product.id,
          quantity: product.quantity,
          properties: {
            _bundle: true
          }
        }
        if (this.isSub && product.sub) {
          item.selling_plan = product.sub
        }
        items.push(item)
      })
      fetch("/cart/add.js", {
        body: JSON.stringify({ items: items }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "post",
      })
      .then((response) => {
        return response.json();
      }).then((body) => {
        this.products = []
        this.selectedFreeGifts = []
        this.grantedFreeGifts = []
        this.updateUI()
        document.dispatchEvent(new CustomEvent('reset-products'))
        window.location.href = "/checkout"
      }).catch((err) => {
        console.error(err);
      });
    }
    intializeSetVariables() {
      const grantedFreeGifts = localStorage.getItem('byo-granted-gifts')
      const selectedFreeGifts = localStorage.getItem('byo-selected-gifts')
      const products = localStorage.getItem('byo-products')
      let needsUpdate = false
      if (grantedFreeGifts) {
        this.grantedFreeGifts = JSON.parse(grantedFreeGifts)
        needsUpdate = true
      }
      if (selectedFreeGifts) {
        this.selectedFreeGifts = JSON.parse(selectedFreeGifts)
        needsUpdate = true
      }
      if (products) {
        this.products = JSON.parse(products)
        this.products.forEach((product) => {
          document.dispatchEvent(new CustomEvent('product-loaded', {
            detail: {
              id: product.id,
              quantity: product.quantity
            }
          }))
        })
        needsUpdate = true
      }
      if (needsUpdate) {
        this.updateUI()
      }
    }
    updateSavedData() {
      localStorage.setItem('byo-granted-gifts',JSON.stringify(this.grantedFreeGifts));
      localStorage.setItem('byo-selected-gifts',JSON.stringify(this.selectedFreeGifts));
      localStorage.setItem('byo-products',JSON.stringify(this.products));
    }
  }
  customElements.define("byo-controller", BYOController);
}

if (!customElements.get("byo-tier")) {
  class BYOTier extends HTMLElement {
    constructor() {
      super();
      this.indicatorActiveClass ='byo-tier__indicator--active'
      this.tierMet = false
      this.tierAmount = this.dataset.amount ? parseInt(this.dataset.amount) : 0
      this.tierType = this.dataset.type
      this.forTierId = this.dataset.for
      this.indicator = this.querySelector('svg')
      this.tierValue = this.querySelector('.tier_value')
    }
    connectedCallback() {
      this.attachListeners()
      this.tierValue = this.querySelector('.tier_value')
    }
    attachListeners() {
      document.addEventListener('selected-free-gift', this.maybeHandleGiftSelected.bind(this))
    }
    getTierAmount() {
      return this.tierAmount
    }
    getTierApplied() {
      return this.tierMet
    }
    maybeApplyTier(amount, alreadyApplied) {
      if (this.tierMet) {
        if (this.tierAmount > amount) {
          this.undoTier()
          this.tierMet = false
        }
      } else {
        if (this.tierAmount <= amount) {
          // Checking if it has already been applied to saved data, don't trigger selectors in that event
          console.log("tier check");
          console.log(alreadyApplied.includes(this.forTierId));
          this.applyTier(!alreadyApplied.includes(this.forTierId))
          this.tierMet = true
        }
      }
    }
    applyTier(triggerTierAction) {
      this.indicator.classList.add(this.indicatorActiveClass)
      this.tierValue.classList.add('hide_button')
      if (triggerTierAction) {
        switch(this.tierType) {
          case 'free_product':
            this.handleAddFreeProduct()
            break;
          case 'select_a_gift':
            this.handleAddSelectAGift()
            break;
        }
      }
    }
    undoTier() {
      this.indicator.classList.remove(this.indicatorActiveClass)
      this.tierValue.classList.remove('hide_button')
      switch(this.tierType) {
        case 'free_product':
          this.handleRemoveFreeProduct()
          break;
        case 'select_a_gift':
          this.handleRemoveSelectAGift()
          break;
      }
    }
    handleAddFreeProduct() {
      const matchingProduct = document.querySelector(`[data-tier="${this.forTierId}"]`);
      console.log(this.forTierId);
      console.log(matchingProduct);
      if (matchingProduct) {
        document.dispatchEvent(new CustomEvent('granted-free-gift', {
          detail: {
            tier: this.forTierId,
            id: matchingProduct.dataset.product,
            title: matchingProduct.dataset.title,
            image: matchingProduct.dataset.image
          }
        }))
      }
    }
    handleAddSelectAGift() {
      const modal = document.querySelector(`.free_full_size_list[data-tier="${this.forTierId}"]`)
      if (modal) {
        modal.classList.remove('dp_none')
        document.querySelector('body').classList.add("body_overflow")
      }
    }
    maybeHandleGiftSelected({detail}) {
      if (detail.tier === this.forTierId) {
        const modal = document.querySelector(`.free_full_size_list[data-tier="${this.forTierId}"]`);
        if (modal) {
          modal.classList.add('dp_none')
          document.querySelector('body').classList.remove("body_overflow")
        }
      }
    }
    handleRemoveFreeProduct() {
      document.dispatchEvent(new CustomEvent('remove-granted-free-gift', {
        detail: {
          tier: this.forTierId,
        }
      }))
    }
    handleRemoveSelectAGift() {
      document.dispatchEvent(new CustomEvent('remove-selected-free-gift', {
        detail: {
          tier: this.forTierId,
        }
      }))
    }
  }
  customElements.define("byo-tier", BYOTier);
}

if (!customElements.get("byo-product")) {
  class BYOProduct extends HTMLElement {
    constructor() {
      super();
      this.quantity = 0
      this.minus = this.querySelector('.quantity__minus')
      this.plus = this.querySelector('.quantity__plus')
      this.mainAdd = this.querySelector('.bundle_add')
      this.product = this.dataset.product
      this.title = this.dataset.title
      this.image = this.dataset.image
      this.sub = this.dataset.sub
      this.attached_events_count = 0
    }
    connectedCallback() {
      this.attachListeners()
    }
    attachListeners() {
      if(!this.attached_events_count){
        if (this.mainAdd) {
          this.mainAdd.addEventListener('click', this.handleMainClick.bind(this))
        }
        if (this.minus) {
          this.minus.addEventListener('click', this.handleMinusClick.bind(this))
        }
        if (this.plus) {
          this.plus.addEventListener('click', this.handlePlusClick.bind(this))
        }
        this.attached_events_count ++;
      }
      document.addEventListener('subscription-on', () => this.togglePricingUI(true))
      document.addEventListener('subscription-off', () => this.togglePricingUI(false))
      document.addEventListener('removed-from-box', this.maybeRemoveItem.bind(this))
      document.addEventListener('product-loaded', this.maybeLoadProduct.bind(this))
      document.addEventListener('reset-products', this.resetProduct.bind(this))
    }
    handlePlusClick() {
      console.log("plus click");
      this.quantity += 1
      document.dispatchEvent(new CustomEvent('update-bundle-item', {
        detail: {
          id: this.product,
          quantity: this.quantity
        }
      }))
      this.updateUI()
    }
    handleMinusClick() {
      this.quantity -= 1
      if (this.quantity <= 0) {
        this.quantity = 0
        document.dispatchEvent(new CustomEvent('remove-from-bundle', {
          detail: {
            id: this.product
          }
        }))
      } else {
        document.dispatchEvent(new CustomEvent('update-bundle-item', {
          detail: {
            id: this.product,
            quantity: this.quantity,
          }
        }))
      }
      this.updateUI()
    }
    handleMainClick() {
      if (this.quantity <= 0 /*&& (!document.querySelector("byo-controller").isSub || this.sub)*/) {
        this.quantity = 1
        document.dispatchEvent(new CustomEvent('add-to-bundle', {
          detail: {
            id: this.product,
            quantity: 1,
            price: this.querySelector(`.pprice_${this.product}`).value,
            sub_price: this.querySelector(`.p_sub_price_${this.product}`).value,
            title: this.title,
            image: this.image,
            sub: this.sub
          }
        }))
        this.updateUI()
      }
    }
    maybeRemoveItem({detail}) {
      if (detail.id == this.product && this.quantity > 0) {
        this.quantity = 0
        this.handleMinusClick()
      }
    }
    updateUI() {
      if (this.quantity > 0) {
        this.querySelector(`.cn_${this.product}`).innerText = this.quantity
        this.querySelector('.quantity__input').value = this.quantity
        this.querySelector(`.bundle_${this.product}`).classList.add('hide_button')
        this.querySelector(`.qty_${this.product}`).classList.remove('hide_button')
        this.querySelector(`.count_product_${this.product}`).classList.remove('hide_button')
      } else {
        this.querySelector(`.bundle_${this.product}`).classList.remove('hide_button')
        this.querySelector(`.qty_${this.product}`).classList.add('hide_button')
        this.querySelector(`.count_product_${this.product}`).classList.add('hide_button')
      }
    }
    togglePricingUI(isSale) {
      // NOTE assess why this wasn't working after callback
      if (isSale) {
        this.querySelector('.span_sub_price')?.classList.remove('hide_button')
        this.querySelector('.span_org_price')?.classList.add('hide_button')
      } else {
        this.querySelector('.span_sub_price')?.classList.add('hide_button')
        this.querySelector('.span_org_price')?.classList.remove('hide_button')      
      }
    }
    maybeLoadProduct({detail}) {
      if (detail.id == this.product) {
        this.quantity = detail.quantity
        this.updateUI()
      }
    }
    resetProduct() {
      this.quantity = 0
      this.updateUI()
    }
  }
  customElements.define("byo-product", BYOProduct);
}

if (!customElements.get("byo-free-product")) {
  class BYOFreeProduct extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define("byo-free-product", BYOFreeProduct);
}
if (!customElements.get("byo-selected-product")) {
  class BYOSelectedProduct extends HTMLElement {
    constructor() {
      super();
      this.tier = this.dataset.tier
      this.product = this.dataset.product
      this.title = this.dataset.title
      this.image = this.dataset.image
      this.mainAdd = this.querySelector('.bundle_free')
    }
    connectedCallback() {
      this.attachListeners()
    }
    attachListeners() {
      this.mainAdd.addEventListener('click', this.handleGiftSelected.bind(this))
    }
    handleGiftSelected() {
      document.dispatchEvent(new CustomEvent('selected-free-gift',{
        detail:
        {
          tier: this.tier,
          id: this.product,
          image: this.image,
          title: this.title
        }
      }))
    }
  }
  customElements.define("byo-selected-product", BYOSelectedProduct);
}